import type { SxProps, Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function SectionCard({ title, subtitle, children, sx }: SectionCardProps) {
  return (
    <Paper sx={{ p: 3, ...sx }}>
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 2
          }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Paper>
  );
}
